<script>
  export let headline =
    "Private Mentorship for Investors With Capital, But No Edge (Yet)";
  export let subheader =
    "Learn How to Trade Options Like Institutions — In 90 Days or Less.";
</script>

<div class="hero">
  <div class="container">
    <div class="inner-container">
      <div class="hero-flex">
        <div class="hero-left">
          <div class="hero-top">
            <div class="hero-logo">
              <img src="/tge-max-logo-square.png" loading="lazy" />
            </div>
            <div class="hero-action">
              <a href="#booking" class="button button-outline">Book a call</a>
              <a href="#pricing" class="button button-filled">See pricing</a>
            </div>
          </div>
          <div class="hero-copy">
            <h1>{headline}</h1>
            <p>{subheader}</p>
          </div>
        </div>
        <div class="hero-membership">
          <div class="hero-membership-card">
            <div class="hero-badge">
              <div class="badge-dot-container">
                <div class="badge-dot"></div>
              </div>
              <div>Start today</div>
            </div>
            <div class="hero-membership-card-title">
              <div class="hero-membership-card-header">
                Turn Your 6-Figure Portfolio
              </div>
              <div class="hero-membership-card-header">
                Into a Data-Driven Trading Machine
              </div>
              <a href="#pricing" class="button">See pricing</a>
            </div>
            <a href="#booking" class="hero-booking-call">
              <div class="booking-container">
                <img src="/imgs/me.jpg" loading="lazy" />
                <div class="booking-details">
                  <div>Book a 15-min intro call</div>
                  <div>Schedule now</div>
                </div>
              </div>
              <span class="booking-svg-container">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-move-right"
                  ><path d="M18 8L22 12L18 16" /><path d="M2 12H22" /></svg
                >
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  @import "../styles/utils";

  .hero {
    padding: 0 5%;
    position: relative;
  }

  .hero-flex {
    display: flex;
    align-items: flex-start;
    gap: 32px;
    flex-flow: column;
  }

  .hero-left {
    flex: 1;
  }

  .hero-top {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    align-items: flex-start;
  }

  .hero-logo {
    width: 60px;
    overflow: hidden;
    position: relative;
    height: 60px;
  }

  .hero-logo img {
    width: 80px;
    height: 80px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    transform: translate(-10px, 0px);
  }

  .button-filled,
  .button-outline {
    margin-top: 0;
    width: initial;
  }

  .hero-action {
    display: none;
    gap: 8px;
  }

  .hero-copy {
    max-width: 310px;
    margin-top: 50px;
  }

  .hero-copy p {
    color: #99948f;
    margin-bottom: 0;
    font-size: 20px;
    max-width: 520px;
  }

  .hero-membership {
    width: 100%;
    border-radius: 20px;
    box-shadow: -40px 40px 40px #000;
  }

  .hero-membership-card {
    color: #000;
    background-color: #fff;
    width: 100%;
    transform-origin: 0 100%;
    overflow: hidden;
    border: 1px solid #000;
    border-radius: 20px;
    padding: 32px;
    transform: rotate(0);
    box-sizing: border-box;
    box-shadow:
      inset 0 2px 1px #ffffff80,
      inset 1px 1px 0.2px #ffffff9e;
  }

  .hero-badge {
    color: #fff;
    background-color: #000;
    border-radius: 100vw;
    align-items: center;
    display: inline-flex;
    padding: 3px 16px 3px 4px;
  }

  .badge-dot-container {
    height: 27px;
    width: 27px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .badge-dot {
    background-color: #3ecf8e;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    position: relative;
  }

  .badge-dot::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #3ecf8e;
    border-radius: 50%;
    opacity: 0.7;
    animation: pulse 1.2s infinite ease-out;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 0.6;
    }
    40% {
      transform: scale(2.8);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
  }

  .hero-membership-card-title {
    margin-top: 80px;
  }

  .hero-membership-card-header {
    font-size: 23px;
    font-weight: 500;
    line-height: 100%;
  }

  .hero-booking-call {
    justify-content: space-between;
    margin-top: 32px;
    display: flex;
    align-items: center;
    color: #000;
  }

  .hero-booking-call .booking-details > div:last-child {
    color: #17171787;
  }

  .booking-svg-container {
    height: 34px;
    width: 34px;
    border-radius: 50%;
    background-color: #000;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .booking-svg-container svg {
    width: 18px;
  }

  .booking-container {
    gap: 12px;
    justify-content: flex-start;
    align-items: center;
    display: flex;
  }

  .booking-container img {
    height: 50px;
    border-radius: 50%;
  }

  @media screen and (min-width: 479px) {
    .hero-membership-card,
    .hero-membership {
      max-width: 390px;
    }

    .hero-top {
      align-items: center;
    }

    .hero-action {
      display: inline-flex;
    }
  }

  @media screen and (min-width: 479px) {
    .hero-copy {
      max-width: none;
    }
  }

  @media screen and (max-width: 479px) {
    .inner-container {
      margin-left: 24px;
      margin-right: 24px;
    }
  }

  @media screen and (max-width: 1024px) {
    .container {
      padding-top: 32px;
    }
  }

  @media screen and (min-width: 1024px) {
    .hero-flex {
      flex-flow: initial;
    }

    .hero-copy {
      /* max-width: 550px; */
      max-width: 100%;
      margin-top: 80px;
    }
  }
</style>
